import React, { useState, useEffect } from 'react'
import { TextArea, TextAreaProps } from './TextArea'
import { Container, CharCount } from './TextAreaWithCharCount.styles'

interface TextAreaWithCharCountProps extends TextAreaProps {
  maxLength: number
}

export const TextAreaWithCharCount = ({
  onChange,
  maxLength,
  value,
  ...rest
}: TextAreaWithCharCountProps) => {
  const [charCount, setCharCount] = useState(
    typeof value === 'string' ? value.length : 0
  )

  useEffect(() => {
    if (typeof value === 'string') {
      setCharCount(value.length)
    }
  }, [value])

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setCharCount(event.target.value.length)

    if (onChange) {
      onChange(event)
    }
  }

  return (
    <Container>
      <TextArea
        {...rest}
        value={value}
        onChange={handleChange}
        maxLength={maxLength}
      />
      <CharCount>{maxLength - charCount} characters left</CharCount>
    </Container>
  )
}
